module.exports = __webpack_public_path__ + "media/images/portal/f-pdf-9b153260e851b94c87392f2bdde60705.png";